import { CloseCircleIcon } from '@mm/icons';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import Datetime from '../../../../../../../common/components/DateTimePicker/DateTimePicker';
import { TimePicker } from '../../../../../../../common/components/TimePicker/TimePicker';
import { useUsersCRUDActions } from '@mm/state/actions/UsersCRUDActions';
import CompanyUsersModel from '@mm/state/model/CompanyUsersModel';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import { Heading } from '@mm/components';
import './AwayUntilDateSelector.scss';

type Props = {
  closeModal: () => void;
  currentUser: CompanyUsersModel;
};

export const AwayUntilDateSelector = (props: Props) => {
  const { closeModal, currentUser } = props;
  const [dayValue, setDayValue] = useState(new Date());
  const [timeValue, setTimeValue] = useState(moment().format('HH-mm'));
  const { update } = useUsersCRUDActions();
  const companyId = useSelector(selectActiveCompanyId);

  const onClickApply = () => {
    const day = moment(dayValue).format('YYYY-MM-DD');
    const dateTime = `${day}-${timeValue}`;
    const awayUntil = moment(dateTime, 'YYYY-MM-DD-HH-mm').toISOString();
    update(companyId, { ...currentUser, awayUntil });
    closeModal();
  };
  return (
    <div className="away-until-date-selector-modal__wrapper">
      <div className="away-until-date-selector-modal">
        <div>
          <div className="away-until-date-selector-modal__header-actions">
            <CloseCircleIcon
              onClick={closeModal}
              className="away-until-date-selector-modal__close-icon"
            />
          </div>
          <div className="away-until-date-selector-modal__header">
            <Heading size={2} text="Away Until" />
          </div>
          <div className="away-until-date-selector-modal__body">
            <div className="away-until-date-selector-modal__day-selector">
              <Heading size={4} text="Day" />
              <Datetime
                value={dayValue}
                dateFormat="Y-m-d"
                enableTime={false}
                onChange={date => setDayValue(date)}
              />
            </div>
            <div className="away-until-date-selector-modal__time-selector">
              <Heading size={4} text="Time" />
              <TimePicker
                value={timeValue}
                onChange={startTime => setTimeValue(startTime)}
              />
            </div>
          </div>
        </div>
        <div className="away-until-date-selector-modal__footer">
          <PrimaryButton
            color={ButtonColor.secondaryBlue}
            onClick={closeModal}
            className="away-until-date-selector-modal__cancel-btn"
          >
            Cancel
          </PrimaryButton>

          <PrimaryButton onClick={onClickApply}>Apply</PrimaryButton>
        </div>
      </div>
    </div>
  );
};
